import { Button, CloseIcon, ConfirmationDialog, TrashIcon, YellowWarningIcon } from '@repo/atomic-components';
import { TimelineChronologyEntry } from '@/store';
import { useTimelineChronologyDelete } from '../hooks';
import { TIMELINE_CHRONOLOGY_LIST_DELETE_MANY } from '@/constants';

interface FooterProps {
  listEntries: TimelineChronologyEntry[];
  selectedEntryIds: string[];
  handleSelectAllEntryIds: () => void;
  handleDeselectAllEntryIds: () => void;
}

export const Footer = ({
  listEntries,
  selectedEntryIds,
  handleSelectAllEntryIds,
  handleDeselectAllEntryIds,
}: FooterProps) => {
  const { handleTimelineChronologyDelete } = useTimelineChronologyDelete();

  return (
    <>
      <ConfirmationDialog
        id={TIMELINE_CHRONOLOGY_LIST_DELETE_MANY}
        style={{ width: '280px', borderRadius: '8px', border: '1px solid #e1e1e0', overflow: 'hidden' }}
        contentClassName="!p-0"
        headerClassName="!hidden"
      >
        {({ entryIds }, { accept, reject }) => {
          return (
            <div className="relative p-[24px]">
              <button
                type="button"
                aria-label="Close"
                onClick={reject}
                className="absolute top-[24px] right-[24px] cursor-pointer rounded p-1 focus:outline-none"
              >
                <CloseIcon width={12} height={12} />
              </button>
              <div className="mt-[16px] flex flex-col items-center">
                <YellowWarningIcon width={48} height={48} />
                <div className="text-fletchers-black-900 mt-[16px] text-[18px]/[18px] font-[600]">Are you sure?</div>
              </div>
              <div className="mt-[16px]">
                <p className="text-center text-[14px]/[20px]">
                  {`${Array.isArray(entryIds) ? entryIds.length : 0} ${Array.isArray(entryIds) && entryIds.length === 1 ? 'entry' : 'entries'} will be deleted.`}
                </p>
              </div>
              <div className="mt-[24px] flex justify-end gap-2">
                <Button outlined className="!h-[32px]" onClick={reject}>
                  Cancel
                </Button>
                <Button className="!h-[32px]" onClick={accept}>
                  Confirm
                </Button>
              </div>
            </div>
          );
        }}
      </ConfirmationDialog>

      {selectedEntryIds.length > 0 && (
        <div className="border-fletchers-gray-100 flex h-[48px] items-center border-t px-6 text-[14px]">
          <div className="flex items-center gap-6">
            <span>{`${selectedEntryIds.length} of ${listEntries.length} selected`}</span>
            <Button text label="Select all" onClick={handleSelectAllEntryIds} className="!px-0 !text-[14px]" />
            <Button text label="Deselect all" onClick={handleDeselectAllEntryIds} className="!px-0 !text-[14px]" />
          </div>

          <div className="ml-auto">
            <Button
              outlined
              icon={<TrashIcon className="text-zinc-950" />}
              label="Delete"
              disabled={!selectedEntryIds.length}
              className="space-x-2 hover:!bg-gray-50"
              onClick={() => {
                handleTimelineChronologyDelete(TIMELINE_CHRONOLOGY_LIST_DELETE_MANY, selectedEntryIds);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
